import type { Theme } from "@mui/material";

/**
 * Shared styling for dropdown surfaces — the `Paper` rendered by `Select`'s menu
 * and by a standalone `Menu`. Keeps both visually identical from one source.
 */
export const dropdownPaperStyles = (theme: Theme) => ({
  maxHeight: 400,
  marginTop: theme.spacing(0.5),
  borderRadius: theme.borderRadius.sm,
  border: "none",
  boxShadow: theme.customShadows.dropdown,
});
